export enum GenerateEventBy {
  INPUT = "INPUT",
  OUTPUT = "OUTPUT",
}
